class PdpBnplShopPay {
  constructor() {
    this.accordion = document.querySelector('.pdp__bnpl--accordion');
    if (!this.accordion) return;

    this.wrapper = this.accordion.querySelector('.pdp__bnpl--shop-pay');
    this.logoButton = this.wrapper?.querySelector('.pdp__bnpl--shop-pay-logo');
    this.host = this.wrapper?.querySelector('shopify-payment-terms');
    if (!this.wrapper || !this.logoButton || !this.host) return;

    this.logoButton.addEventListener('click', () => this.openModal());
  }

  getLearnMoreButton() {
    const root = this.host.shadowRoot;
    if (!root) return null;

    return (
      root.querySelector('button[aria-haspopup="dialog"]') ||
      root.querySelector('#shopify-installments button') ||
      root.querySelector('button')
    );
  }

  openModal(attempt = 0) {
    const learnMoreButton = this.getLearnMoreButton();

    if (!learnMoreButton) {
      if (attempt < 10) {
        window.setTimeout(() => this.openModal(attempt + 1), 200);
      }
      return;
    }

    learnMoreButton.click();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PdpBnplShopPay();
});
